import script from "./stopDetailsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./stopDetailsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./stopDetailsComponent.vue?vue&type=style&index=0&id=64940591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64940591"]])

export default __exports__